import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
const CHECKOUT_URL = '[TU_LINK_MERCADOPAGO_BASE]';
export function FinalCTASection() {
  const {
    ref,
    isInView
  } = useInView();
  const goToCheckout = () => {
    const pixelId = '[TU_PIXEL_ID]';
    const contentName = 'CONTROLA LA ANSIEDAD — Pack Completo Base';
    const contentId = 'ANSIEDAD_BASE_001';
    const value = 19990;
    const w = window as any;
    if (typeof w.fbq === 'function') {
      w.fbq('track', 'InitiateCheckout', {
        content_name: contentName,
        content_ids: [contentId],
        value: value,
        currency: 'ARS'
      });
    }
    const img = new Image(1, 1);
    const params = new URLSearchParams({
      id: pixelId,
      ev: 'InitiateCheckout',
      noscript: '1',
      'cd[content_name]': contentName,
      'cd[value]': String(value),
      'cd[currency]': 'ARS'
    });
    img.src = `https://www.facebook.com/tr?${params.toString()}`;
    setTimeout(() => {
      window.open(CHECKOUT_URL, '_blank');
    }, 300);
  };
  return <section className="py-14 px-4 bg-primary border-y border-accent-gold/20 relative" ref={ref} data-id="element-45">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5
      }} data-id="element-47">
          <span className="text-accent-gold font-bold text-sm uppercase tracking-widest mb-4 block" data-id="element-48">
            ⏰ LA OFERTA TERMINA PRONTO
          </span>

          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-49">
            Cada día que esperás es otro día viviendo con miedo.
          </h2>

          <p className="text-accent-teal text-xl mb-6" data-id="element-50">
            Hoy podés tener todo el pack en tu celular en menos de 2 minutos.
          </p>

          <div className="mb-6" data-id="element-51">
            <span className="text-text-secondary line-through text-2xl mr-4" data-id="element-52">
              $39.990
            </span>
            <span className="text-accent-gold font-bold text-5xl" data-id="element-53">
              $19.990 ARS
            </span>
            <p className="text-text-secondary text-sm mt-2" data-id="element-54">
              Pago único · Acceso de por vida
            </p>
          </div>

          <button onClick={goToCheckout} className="w-full max-w-lg mx-auto bg-accent-gold text-primary font-bold text-xl sm:text-2xl py-6 px-8 rounded-2xl hover:scale-[1.05] transition-transform duration-300 glow-gold block mb-6" data-id="element-55">
            🧠 QUIERO CONTROLAR MI ANSIEDAD AHORA →
          </button>

          <p className="text-text-secondary text-sm" data-id="element-56">
            🔒 Acceso inmediato · ↩️ Garantía por inconvenientes · 💳 Hasta 12
            cuotas
          </p>
        </motion.div>
      </div>
    </section>;
}